import { ModulosEnum } from '@/enums/ModulosEnum'

export interface ModuloDisplayInfo {
  label: string
  parentLabel?: string
}

export const MODULO_DISPLAY_INFO: Partial<Record<ModulosEnum, ModuloDisplayInfo>> = {
  [ModulosEnum.CADASTROS_CLIENTES]: { label: 'Clientes', parentLabel: 'Cadastros' },
  [ModulosEnum.CADASTROS_ESPECIE_PAGAMENTO]: { label: 'Espécies de Pagamento', parentLabel: 'Cadastros' },
  [ModulosEnum.CADASTROS_CATEGORIAS]: { label: 'Categorias', parentLabel: 'Cadastros' },
  [ModulosEnum.GESTAO_FLUXO_DE_CAIXA]: { label: 'Financeiro' },
  [ModulosEnum.GESTAO_FLUXO_DE_CAIXA_FLUXO_CAIXA]: { label: 'Fluxo de Caixa', parentLabel: 'Financeiro' },
  [ModulosEnum.GESTAO_FLUXO_DE_CAIXA_CAIXAS]: { label: 'Caixas', parentLabel: 'Financeiro' },
  [ModulosEnum.COMUNICACAO_EM_LOTE_EMAIL]: { label: 'E-mail', parentLabel: 'Comunicação em Lote' },
  [ModulosEnum.COMUNICACAO_EM_LOTE_SMS]: { label: 'SMS', parentLabel: 'Comunicação em Lote' },
  [ModulosEnum.COMUNICACAO_EM_LOTE_WHATSAPP]: { label: 'WhatsApp', parentLabel: 'Comunicação em Lote' },
  [ModulosEnum.ANALISE_DE_CREDITO]: { label: 'Análise de Crédito' },
  [ModulosEnum.SERASA]: { label: 'Consulta Serasa' },
  [ModulosEnum.SERASA_NEGATIVACAO]: { label: 'Negativação' },
  [ModulosEnum.HIGIENIZACAO]: { label: 'Higienização' },
  [ModulosEnum.AUTOMACAO_COMUNICACAO_COBRANCAS]: { label: 'Automatização de Cobranças' },
  [ModulosEnum.RELATORIOS]: { label: 'Relatórios' },
  [ModulosEnum.NOTAS_FISCAIS]: { label: 'Notas Fiscais' },
}

export function getModuloBlockLabel(moduleCode?: ModulosEnum | string | null): string | null {
  if (!moduleCode) return null
  const info = MODULO_DISPLAY_INFO[moduleCode as ModulosEnum]
  if (!info) return null
  return info.parentLabel ? `${info.parentLabel} - ${info.label}` : info.label
}
